/* reporté de theme.liquid code custom inline 2026-09-17 */
/* (16 oct. 2026) Ancien script de synchronisation du formulaire ShipAid retiré : ShipAid est en pause et son widget n'est plus affiché. */

document.addEventListener('DOMContentLoaded', function () {
  function isEnglishPage() {
    return window.location.pathname.startsWith('/en/');
  }

  if (!isEnglishPage()) return;

  const translations = {
    "Quels termes décrivent le produit que vous avez acheté ? Vous pouvez en choisir plus d'un.": "Which terms describe the product you purchased? You can choose more than one.",
    "Sélectionnez autant que vous le souhaitez": "Select as many as you like",

    "Belle qualité": "Great quality",
    "Fidèle à la description": "Accurate description",
    "Bon rapport qualité-prix": "Good value for money",
    "Livraison rapide": "Fast delivery",
    "Bien emballé": "Well packaged",
    "Je recommande": "I recommend it"
  };

  function replaceJudgeMeText() {
    document.querySelectorAll('body *').forEach(function (el) {
      if (el.children.length > 0) return;

      const text = el.textContent.trim();

      if (translations[text]) {
        el.textContent = translations[text];
      }
    });
  }

  replaceJudgeMeText();

  const observer = new MutationObserver(function () {
    replaceJudgeMeText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
(function () {
  const synonyms = {
  'chandelle': ['chandelle', 'bougie'],
  'bougie': ['bougie', 'chandelle'],

  'amour': ['amour', 'love', 'cayer'],
  'love': ['amour', 'love', 'cayer'],
  'cayer': ['amour', 'love', 'cayer'],

  'affiche': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'affiches': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'poster': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'posters': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'print': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'prints': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],

  'agenda': ['agenda', 'agendas', 'planner', 'planners'],
  'agendas': ['agenda', 'agendas', 'planner', 'planners'],
  'planner': ['agenda', 'agendas', 'planner', 'planners'],
  'planners': ['agenda', 'agendas', 'planner', 'planners']
};

  document.addEventListener('submit', function(event) {
    const form = event.target;

    if (!form.matches('form[action*="/search"]')) return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const originalQuery = input.value.trim();
    const query = originalQuery.toLowerCase();

    if (!synonyms[query]) {
      sessionStorage.removeItem('slSynonymSearch');
      return;
    }

    event.preventDefault();

    const expandedQuery =
      '(' + synonyms[query].join(' OR ') + ')';

    sessionStorage.setItem(
      'slSynonymSearch',
      JSON.stringify({
        original: originalQuery,
        expanded: expandedQuery
      })
    );

    /* On construit la recherche sans modifier le champ visible */
    const params = new URLSearchParams(new FormData(form));
    params.set('q', expandedQuery);

    const url = new URL(form.action, window.location.origin);

    params.forEach(function(value, key) {
      url.searchParams.set(key, value);
    });

    window.location.assign(url.toString());
  });

  (function restoreSynonymDisplay() {
    const saved = sessionStorage.getItem('slSynonymSearch');

    if (!saved) {
      document.documentElement.classList.remove('sl-synonym-search-loading');
      return;
    }

    let searchData;

    try {
      searchData = JSON.parse(saved);
    } catch (e) {
      document.documentElement.classList.remove('sl-synonym-search-loading');
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const actualQuery = params.get('q') || '';

    if (actualQuery !== searchData.expanded) {
      document.documentElement.classList.remove('sl-synonym-search-loading');
      return;
    }

    const originalQuery = searchData.original;

    /* Affiche seulement le terme réellement tapé */
    document.querySelectorAll(
      'form[action*="/search"] input[name="q"]'
    ).forEach(function(input) {
      input.value = originalQuery;
    });

    /* Corrige le gros titre */
    const heading = document.querySelector(
      '.shopify-section--main-search h1.h2.text-center'
    );

    /*if (heading) {
      const count = {{ search.results_count | default: 0 | json }};

      if (document.documentElement.lang.toLowerCase().startsWith('en')) {
        heading.textContent =
          count + ' result' + (count === 1 ? '' : 's') +
          ' for "' + originalQuery + '"';
      } else {
        heading.textContent =
          count + ' résultat' + (count === 1 ? '' : 's') +
          ' pour "' + originalQuery + '"';
      }
    }*/

    /* Tout est corrigé : on affiche la zone */
    document.documentElement.classList.remove('sl-synonym-search-loading');
})();
})();

/* reporté de header.liquid code custom inline 2026-09-17
   Réactivé le 16 oct. 2026 : {{ section.id }} n'est pas interprété dans un fichier .js ; on retrouve la section
   de l'en-tête à partir de la barre de recherche elle-même (.mobile-sticky-search, sections/header.liquid). */
(function () {
    function initMobileSearchStickiness() {
      const barre = document.querySelector('.mobile-sticky-search');
      const section = barre ? barre.closest('.shopify-section') : null;
      if (!section) return;

      const searchBar = section.querySelector('.mobile-sticky-search');
      if (!searchBar) return;
      const desktopSearch = section.querySelector(
        'store-header .header__icon-list a[aria-controls="search-drawer"]'
      );

      let placeholder = section.querySelector('.mobile-sticky-search-placeholder');

      if (!placeholder) {
        placeholder = document.createElement('div');
        placeholder.className = 'mobile-sticky-search-placeholder';
        searchBar.parentNode.insertBefore(placeholder, searchBar);
      }

      let triggerY = 0;
      let ticking = false;

      function reset() {
        searchBar.classList.remove('is-fixed');
        placeholder.classList.remove('is-active');
        placeholder.style.height = '0px';
      }

      function measure() {
  reset();

  if (window.innerWidth >= 700) {
  if (desktopSearch) {
    const desktopSearchRect = desktopSearch.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const rightOffset = Math.max(
  0,
  viewportWidth - desktopSearchRect.right - 36
  );

    searchBar.style.setProperty(
      '--desktop-search-right',
      rightOffset + 'px'
    );
  }

  triggerY =
    section.getBoundingClientRect().bottom +
    window.scrollY;

  placeholder.style.height = '0px';
  } else {
    triggerY =
      searchBar.getBoundingClientRect().top +
      window.scrollY;

    placeholder.style.height =
      searchBar.offsetHeight + 'px';
  }

  update();
}

      function update() {
        

        if (window.scrollY > triggerY) {
          searchBar.classList.add('is-fixed');
          placeholder.classList.add('is-active');
        } else {
          searchBar.classList.remove('is-fixed');
          placeholder.classList.remove('is-active');
        }
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            update();
            ticking = false;
          });

          ticking = true;
        }
      }, { passive: true });

      window.addEventListener('resize', measure);

      measure();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileSearchStickiness);
    } else {
      initMobileSearchStickiness();
    }
  })();

/* ==========================================================================
   Rattrapage du 16 oct. 2026 : fonctions reprises du thème en ligne
   ========================================================================== */

/* En-tête compact sur ordinateur (1150 px et plus) : l'en-tête reste fixé en haut au défilement, puis se compacte
   (le menu principal se replie) après 60 px. Styles : sl-theme.css, 3.9. Repris du bloc Liquid personnalisé
   custom_liquid_N47x8X de l'en-tête du thème en ligne. */
(function () {
  function init() {
    var tete = document.querySelector('store-header');
    if (!tete || tete.dataset.slFixe) return;
    tete.dataset.slFixe = '1';
    var boite = tete.parentElement;
    var fixe = false;
    var compact = false;
    var attente = false;
    function maj() {
      attente = false;
      var large = window.innerWidth >= 1150;
      var haut = boite.getBoundingClientRect().top;
      var veutFixe = large && haut < 0;
      var veutCompact = veutFixe && haut < -60;
      if (veutFixe && !fixe) {
        boite.style.minHeight = boite.offsetHeight + 'px';
        tete.classList.add('sl-fixe');
        fixe = true;
      }
      if (veutCompact !== compact) {
        compact = veutCompact;
        tete.classList.toggle('sl-compact', compact);
        if (compact) {
          tete.querySelectorAll('.header__main-nav details[open]').forEach(function (d) { d.removeAttribute('open'); });
        }
      }
      if (!veutFixe && fixe) {
        tete.classList.remove('sl-fixe');
        boite.style.minHeight = '';
        fixe = false;
      }
    }
    function demande() {
      if (!attente) { attente = true; window.requestAnimationFrame(maj); }
    }
    window.addEventListener('scroll', demande, { passive: true });
    window.addEventListener('resize', demande);
    maj();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Fiche produit, carte « Service client disponible » : le lien ouvre la bulle Shopify Inbox
   (bouton caché dans le shadow DOM de l'app). Lien marqué data-sl-ouvrir-clavardage dans
   snippets/sl-product-reassurance-card.liquid. */
(function () {
  function chercher(selecteur, racine) {
    racine = racine || document;
    var direct = racine.querySelector(selecteur);
    if (direct) return direct;
    var tous = racine.querySelectorAll('*');
    for (var i = 0; i < tous.length; i++) {
      if (tous[i].shadowRoot) {
        var trouve = chercher(selecteur, tous[i].shadowRoot);
        if (trouve) return trouve;
      }
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var lien = e.target.closest('[data-sl-ouvrir-clavardage]');
    if (!lien) return;
    e.preventDefault();
    var bouton = chercher('button[data-spec="toggle-button"]');
    if (!bouton) return;
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
      bouton.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
    });
  });
})();

/* Page panier : la case « commande cadeau » affiche ou cache le champ du message (déplacé de sections/main-cart.liquid).
   La case n'existe pas quand le panier est vide.
   3 nov. 2026, Claude, demande de Dawei : nouvelle case (snippets/sl-cadeau-panier.liquid). Le champ s'ouvre avec
   l'attribut hidden au lieu de opacity et height, la carte prend la classe is-on, et un compteur affiche les
   caractères restants sur 250. Ancien code gardé en commentaire juste en dessous. */
/* (function () {
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'gift_order_yes') return;
    var champ = document.getElementById('gift_order_note_container');
    if (!champ) return;
    champ.style.opacity = e.target.checked ? '1' : '0';
    champ.style.height = e.target.checked ? '130px' : '0';
  });
})(); */
(function () {
  function compter(texte) {
    var compte = document.querySelector('[data-sl-cadeau-compte]');
    if (!compte || !texte) return;
    var n = Math.max(0, (parseInt(texte.getAttribute('maxlength'), 10) || 250) - texte.value.length);
    var modele = compte.getAttribute(n === 1 ? 'data-un' : 'data-plusieurs');
    if (modele) compte.textContent = modele.replace('[n]', n);
  }
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'gift_order_yes') return;
    var champ = document.getElementById('gift_order_note_container');
    if (!champ) return;
    champ.hidden = !e.target.checked;
    var carte = e.target.closest('.sl-cadeau');
    if (carte) carte.classList.toggle('is-on', e.target.checked);
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'gift_order_note') compter(e.target);
  });
})();

/* Page « Créez votre boîte-cadeau personnalisée » (sections/sl-boite-cadeau.liquid) :
   - bouton « Étape suivante » : ouvre l'onglet suivant et le ramène à l'écran ;
   - « Sauvegarder le message » : enregistre le message dans les attributs du panier sans quitter la page
     (l'ancienne version utilisait jQuery, retiré du thème). « Sauvegarder et passer la commande » reste un envoi normal. */
(function () {
  document.addEventListener('click', function (e) {
    var suivant = e.target.closest('[data-sl-etape-suivante]');
    if (suivant) {
      var onglets = suivant.closest('x-tabs');
      if (!onglets) return;
      var boutons = Array.prototype.slice.call(onglets.querySelectorAll('button[slot="title"]'));
      var panneaux = Array.prototype.slice.call(onglets.querySelectorAll('[role="tabpanel"]'));
      var k = panneaux.indexOf(suivant.closest('[role="tabpanel"]'));
      if (k >= 0 && boutons[k + 1]) {
        boutons[k + 1].click();
        boutons[k + 1].scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      return;
    }
    var sauver = e.target.closest('[data-sl-message-cadeau] [name="save_message"]');
    if (sauver) {
      e.preventDefault();
      var form = sauver.closest('form');
      var etat = form.querySelector('[data-sl-message-etat]');
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        if (etat && r.ok) { etat.hidden = false; }
      }).catch(function () {});
    }
  });
})();

/* Panier, barre de livraison gratuite à 2 paliers (snippets/free-shipping-bar-2-milestones.liquid), repris du thème
   en ligne (15 oct. 2026). Le script d'Impact (FreeShippingBar._updateMessage) cherche un message à un seul palier
   qui n'existe pas dans cette barre : il plantait à chaque changement du panier (« Cannot read properties of null »).
   1) Le script d'Impact ne touche plus au message de cette barre (la progression continue d'avancer normalement) ;
   2) à chaque changement du panier, on reprend la barre recalculée par Shopify (jointe à la réponse du panier,
      sinon demandée au serveur) et on remplace le message et les paliers atteints. */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('free-shipping-bar').then(function () {
    var C = customElements.get('free-shipping-bar');
    var original = C && C.prototype._updateMessage;
    if (!original) return;
    C.prototype._updateMessage = function () {
      if (this.querySelector('.free-shipping-bar__message')) return;
      return original.apply(this, arguments);
    };
  });
  function majBarres(html) {
    var neuve = html && new DOMParser().parseFromString(html, 'text/html').querySelector('free-shipping-bar');
    if (!neuve) return false;
    Array.prototype.forEach.call(document.querySelectorAll('free-shipping-bar'), function (b) {
      ['.free-shipping-bar__message', '.progress-bar__milestones'].forEach(function (sel) {
        var actuel = b.querySelector(sel), nouveau = neuve.querySelector(sel);
        if (actuel && nouveau) actuel.innerHTML = nouveau.innerHTML;
      });
      ['data-total-price', 'data-progress'].forEach(function (att) {
        if (neuve.hasAttribute(att)) b.setAttribute(att, neuve.getAttribute(att));
      });
    });
    return true;
  }
  document.addEventListener('cart:change', function (e) {
    if (!document.querySelector('free-shipping-bar .free-shipping-bar__message')) return;
    var s = e.detail && e.detail.cart && e.detail.cart.sections, html = null;
    if (s) for (var k in s) { if (s[k] && s[k].indexOf('<free-shipping-bar') > -1) { html = s[k]; break; } }
    if (majBarres(html)) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { majBarres(j['cart-drawer']); })
      .catch(function () {});
  });
})();

/* Recommandations du tiroir du panier : composant <cart-recommendations> (snippets/sl-tiroir-recommandations.liquid).
   Repris du thème en ligne, où il avait été ajouté dans assets/theme.js d'Impact. Pour chacun des 3 premiers produits
   du panier, on demande la section cart-drawer-recommendations-source dans le contexte de ce produit, puis on répartit
   les places (data-limit, 6) entre eux, sans doublon ni produit déjà au panier. */
(function () {
  if (!window.customElements || window.customElements.get('cart-recommendations')) return;
  var CartRecommendations = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this._loadRecommendations();
    }
  
    disconnectedCallback() {
      this._abortController?.abort();
    }
  
    async _loadRecommendations() {
      const layoutTemplate = this.querySelector(
        "template[data-recommendations-layout]"
      );
  
      const sectionId = this.dataset.sectionId;
  
      const limit = Math.max(
        1,
        parseInt(this.dataset.limit || "4", 10)
      );
  
      if (!layoutTemplate || !sectionId) {
        return;
      }
  
      let productIds = [];
      let productHandles = [];
  
      try {
        productIds = JSON.parse(
          this.dataset.productIds || "[]"
        );
      } catch (error) {
        console.error(
          "Unable to read cart product IDs:",
          error
        );
      }
  
      try {
        productHandles = JSON.parse(
          this.dataset.productHandles || "[]"
        );
      } catch (error) {
        console.error(
          "Unable to read cart product handles:",
          error
        );
      }
  
      productIds = [
        ...new Set(
          productIds
            .map(String)
            .filter(Boolean)
        )
      ];
  
      /*
       * On analyse au maximum les trois premiers
       * produits distincts du panier.
       */
      productHandles = [
        ...new Set(
          productHandles
            .map(String)
            .filter(Boolean)
        )
      ].slice(0, 3);
  
      if (productHandles.length === 0) {
        return;
      }
  
      const seenProductIds = new Set(productIds);
      const recommendationTemplates = [];
  
      try {
        /*
         * Charge la section dans le contexte de chaque
         * page produit afin que Liquid utilise le bon produit.
         */
        const responseResults =
          await Promise.allSettled(
            productHandles.map(
              async (productHandle) => {
                const productPath =
                  `${Shopify.routes.root}products/` +
                  `${encodeURIComponent(productHandle)}`;
  
                const url =
                  `${productPath}?section_id=` +
                  `${encodeURIComponent(sectionId)}`;
  
                const response = await fetch(url, {
                  signal: this._abortController.signal
                });
  
                return response.ok
                  ? response.text()
                  : "";
              }
            )
          );
  
        if (this._abortController.signal.aborted) {
          return;
        }
  
        const parser = new DOMParser();
  
        const recommendationGroups =
          responseResults.map((result) => {
            if (
              result.status !== "fulfilled" ||
              !result.value
            ) {
              return [];
            }
  
            const documentFromResponse =
              parser.parseFromString(
                result.value,
                "text/html"
              );
  
            return Array.from(
              documentFromResponse.querySelectorAll(
                "template[data-similar-product-id]"
              )
            );
          });
  
        const groupIndexes =
          recommendationGroups.map(() => 0);
  
        const groupAddedCounts =
          recommendationGroups.map(() => 0);
  
        const maxPerSource =
          recommendationGroups.length > 1
            ? Math.ceil(
                limit / recommendationGroups.length
              )
            : limit;
  
        const addNextFromGroup = (groupIndex) => {
          const group =
            recommendationGroups[groupIndex];
  
          while (
            groupIndexes[groupIndex] < group.length
          ) {
            const template =
              group[groupIndexes[groupIndex]];
  
            groupIndexes[groupIndex] += 1;
  
            const recommendedProductId =
              template.dataset.similarProductId;
  
            if (
              !recommendedProductId ||
              seenProductIds.has(recommendedProductId)
            ) {
              continue;
            }
  
            seenProductIds.add(recommendedProductId);
            recommendationTemplates.push(template);
            groupAddedCounts[groupIndex] += 1;
  
            return true;
          }
  
          return false;
        };
  
        let addedInRound = true;
  
        /*
         * Première passe équilibrée :
         * chaque produit du panier reçoit sa part.
         */
        while (
          recommendationTemplates.length < limit &&
          addedInRound
        ) {
          addedInRound = false;
  
          for (
            let groupIndex = 0;
            groupIndex < recommendationGroups.length;
            groupIndex += 1
          ) {
            if (
              groupAddedCounts[groupIndex] >=
              maxPerSource
            ) {
              continue;
            }
  
            if (addNextFromGroup(groupIndex)) {
              addedInRound = true;
            }
  
            if (
              recommendationTemplates.length >= limit
            ) {
              break;
            }
          }
        }
  
        /*
         * Deuxième passe :
         * complète les places restantes lorsqu'un groupe
         * ne possède pas assez de produits similaires.
         */
        addedInRound = true;
  
        while (
          recommendationTemplates.length < limit &&
          addedInRound
        ) {
          addedInRound = false;
  
          for (
            let groupIndex = 0;
            groupIndex < recommendationGroups.length;
            groupIndex += 1
          ) {
            if (addNextFromGroup(groupIndex)) {
              addedInRound = true;
            }
  
            if (
              recommendationTemplates.length >= limit
            ) {
              break;
            }
          }
        }
      } catch (error) {
        if (error.name === "AbortError") {
          return;
        }
  
        console.error(
          "Unable to load similar cart products:",
          error
        );
      }
  
      if (recommendationTemplates.length === 0) {
        return;
      }
  
      const layout = document.importNode(
        layoutTemplate.content,
        true
      );
  
      const listElement = layout.querySelector(
        "[data-recommendations-list]"
      );
  
      if (!listElement) {
        return;
      }
  
      recommendationTemplates.forEach((template) => {
        listElement.append(
          document.importNode(
            template.content,
            true
          )
        );
      });
  
      if (recommendationTemplates.length <= 1) {
        layout
          .querySelector(
            "[data-recommendation-controls]"
          )
          ?.remove();
      }
      
      // SL — Desktop sidebar is vertical; do not mount Impact's horizontal
      // scroll-carousel component here. It retains a horizontal viewport
      // that clips the recommendation list despite its full-height aside.
      // Keep the native carousel untouched on narrower screens.
      if (window.matchMedia('(min-width: 1100px)').matches) {
        const carousel = layout.querySelector(
          '#cart-drawer-dynamic-recommendations'
        );
        if (carousel) {
          const verticalList = document.createElement('div');
          verticalList.className = 'sl-cart-recommendations-vertical';
          verticalList.append(...Array.from(carousel.childNodes));
          carousel.replaceWith(verticalList);
        }
      }

      this.replaceChildren(layout);
      this.hidden = false;
    }
  };
  window.customElements.define('cart-recommendations', CartRecommendations);
})();

/* Blogue Le Répertoire (sections/main-blog-repertoire.liquid) : au chargement, la rangée de filtres défile jusqu'au
   filtre actif. Réécrit sans jQuery le 16 oct. 2026 (l'ancien script plantait : « jQuery is not defined »). */
window.addEventListener('load', function () {
  document.querySelectorAll('.blog-banner .scroll-area').forEach(function (zone) {
    var actif = zone.querySelector('li[aria-selected="true"]');
    if (!actif) return;
    var decalage = actif.getBoundingClientRect().left - zone.getBoundingClientRect().left + zone.scrollLeft;
    if (decalage > zone.scrollLeft) {
      zone.scrollTo({ left: decalage, behavior: 'smooth' });
    }
  });
});

/* ==========================================================================
   Fiche produit (repris du thème en ligne le 16 oct. 2026, où ce code était écrit dans sections/main-product.liquid)
   ========================================================================== */

/* Barre d'ajout rapide (sections/main-product.liquid) : le sous-total suit la quantité choisie.
   Le prix unitaire vient de data-sl-prix-unitaire, que product-rerender d'Impact remet à jour à chaque changement
   de variante. Le texte n'est réécrit que s'il change (l'ancienne version réécrivait sans arrêt et tournait en boucle). */
(function () {
  function sousTotal() {
    var el = document.querySelector('.product-quick-add__subtotal[data-sl-prix-unitaire]');
    if (!el) return;
    var barre = el.closest('product-quick-add');
    var formId = barre ? barre.getAttribute('form') : null;
    var qte = 1;
    if (formId) {
      var champ = document.querySelector('input[name="quantity"][form="' + formId + '"], #' + formId + ' input[name="quantity"]');
      var n = champ ? parseInt(champ.value, 10) : 1;
      if (n > 0) qte = n;
    }
    var prix = Number(el.getAttribute('data-sl-prix-unitaire')) || 0;
    var langue = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0 ? 'en-CA' : 'fr-CA';
    var texte = new Intl.NumberFormat(langue, { style: 'currency', currency: 'CAD' }).format(prix * qte / 100);
    if (el.textContent !== texte) el.textContent = texte;
  }
  function plusTard() { requestAnimationFrame(function () { requestAnimationFrame(sousTotal); }); }
  document.addEventListener('change', function (e) { if (e.target.closest('quantity-selector, input[name="quantity"], variant-picker, form')) plusTard(); });
  document.addEventListener('input', function (e) { if (e.target.matches('input[name="quantity"]')) plusTard(); });
  document.addEventListener('click', function (e) { if (e.target.closest('quantity-selector button')) plusTard(); });
  document.addEventListener('variant:change', plusTard);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sousTotal); } else { sousTotal(); }
})();

/* Zoom des photos (ordinateur, 1000 px et plus) : un clic sur la photo l'agrandit 2 fois et elle suit la souris,
   un 2e clic (ou un clic ailleurs) la remet normale. Flèches précédente et suivante sur la photo.
   Balisage : .product-gallery__hover-zoom-container--active dans snippets/product-gallery.liquid ; styles : sl-theme.css, 5.6. */
(function () {
  function preparer(container) {
    if (container.dataset.zoomBound) return;
    var img = container.querySelector('img');
    if (!img) return;
    container.dataset.zoomBound = 'true';
    var mediaCarousel = container.closest('product-gallery') ? container.closest('product-gallery').querySelector('media-carousel') : null;
    var plusieurs = mediaCarousel && mediaCarousel.items && mediaCarousel.items.length > 1;
    var prevBtn = null, nextBtn = null;
    function visibilite() {
      if (!mediaCarousel || !plusieurs) return;
      var items = mediaCarousel.visibleItems || mediaCarousel.items || [];
      var k = items.indexOf(mediaCarousel.selectedSlide);
      if (prevBtn) prevBtn.style.display = k > 0 ? 'flex' : 'none';
      if (nextBtn) nextBtn.style.display = k < items.length - 1 ? 'flex' : 'none';
    }
    function fleche(sens) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'product-gallery__hover-zoom-nav product-gallery__hover-zoom-nav--' + (sens < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', sens < 0 ? 'Previous image' : 'Next image');
      b.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="' + (sens < 0 ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6') + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        if (sens < 0) mediaCarousel.previous(); else mediaCarousel.next();
        setTimeout(visibilite, 100);
      }, true);
      container.appendChild(b);
      return b;
    }
    if (mediaCarousel && plusieurs) {
      prevBtn = fleche(-1); nextBtn = fleche(1);
      mediaCarousel.addEventListener('carousel:settle', visibilite);
      visibilite();
    }
    function suivre(e) {
      if (!container.classList.contains('is-click-zoomed') || e.target.closest('.product-gallery__hover-zoom-nav')) return;
      e.preventDefault(); e.stopPropagation();
      var r = container.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      var y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
      img.style.transform = 'scale(2) translate(' + ((0.5 - x) * r.width / 2) + 'px, ' + ((0.5 - y) * r.height / 2) + 'px)';
    }
    function fermer() {
      container.classList.remove('is-click-zoomed');
      container.removeEventListener('mousemove', suivre);
      img.style.transform = 'scale(1) translate(0, 0)';
    }
    function clic(e) {
      if (window.innerWidth < 1000 || e.target.closest('.product-gallery__hover-zoom-nav')) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (container.classList.contains('is-click-zoomed')) { fermer(); }
      else { container.classList.add('is-click-zoomed'); container.addEventListener('mousemove', suivre, { passive: false }); suivre(e); }
    }
    container.addEventListener('click', clic, true);
    document.addEventListener('click', function (e) {
      if (container.classList.contains('is-click-zoomed') && !container.contains(e.target)) fermer();
    }, true);
  }
  function tout() { document.querySelectorAll('.product-gallery__hover-zoom-container--active').forEach(preparer); }
  function demarrer() {
    tout();
    var galerie = document.querySelector('product-gallery');
    if (galerie) new MutationObserver(function () { setTimeout(tout, 100); }).observe(galerie, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', demarrer); } else { demarrer(); }
})();

/* Galerie sur cellulaire (moins de 1000 px) : un glissement vertical sur la photo fait défiler la page au lieu
   d'être capté par le carrousel. */
(function () {
  if (!window.matchMedia('(max-width: 999px)').matches) return;
  function preparer() {
    var c = document.querySelector('media-carousel.product-gallery__media-list');
    if (!c || c.dataset.slVertical) return;
    c.dataset.slVertical = '1';
    var x0 = 0, y0 = 0, sens = null;
    c.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; sens = null; }
    }, { passive: true, capture: true });
    c.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1 || (!x0 && !y0)) return;
      var dx = Math.abs(e.touches[0].clientX - x0), dy = Math.abs(e.touches[0].clientY - y0);
      if (sens === null) {
        if (dy > dx && dy > 10) sens = 'vertical';
        else if (dx > dy && dx > 10) sens = 'horizontal';
      }
      if (sens === 'vertical') e.stopPropagation();
    }, { passive: false, capture: true });
    c.addEventListener('touchend', function () { x0 = 0; y0 = 0; sens = null; }, { passive: true, capture: true });
  }
  function demarrer() {
    preparer();
    var galerie = document.querySelector('product-gallery');
    if (galerie) new MutationObserver(function () { setTimeout(preparer, 100); }).observe(galerie, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', demarrer); } else { demarrer(); }
})();

/* ==========================================================================
   Carrousels : les flèches vont jusqu'à la dernière carte (2 nov. 2026, Claude, demande de Dawei)
   ========================================================================== */

/* Sur grand écran (1920 px et plus), les flèches des carrousels d'Impact (scroll-carousel) s'arrêtaient une carte
   ou plus avant la fin : select() de theme.js plafonne l'index à totalPages, calculé jusqu'au bord de l'écran,
   alors que la fin du défilement aligne la dernière carte sur la marge du contenu. On autorise l'index jusqu'à
   la vraie fin du défilement (scrollWidth - clientWidth). Le reste de select() est identique à theme.js (Impact).
   Même correctif que le snippet sl-fin-carrousel du 1er oct. (thème « OFFICIEL (16 OCTOBRE) »), qui n'avait pas été
   repris dans « 22 octobre » ; mis ici plutôt que dans un snippet, selon les règles de code de Valérie.
   Testé le 2 nov. sur l'accueil : 1920 et 2560 px corrigés, 1440 et 1280 px inchangés.
   À revoir si Impact est mis à jour : comparer avec select() du nouveau theme.js. */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('scroll-carousel').then(function () {
    var C = customElements.get('scroll-carousel');
    if (!C || C.prototype.__slFinCarrousel) return;
    C.prototype.__slFinCarrousel = true;
    C.prototype.select = function (index, options) {
      options = options || {};
      var animate = options.animate !== undefined ? options.animate : true;
      var force = !!options.force;
      var indexBeforeChange = this.selectedIndex;
      if (!this.offsetParent || this._scrollArea.scrollDirection === 'none') {
        return this._selectedIndex = index;
      }
      var visible = this.visibleItems;
      var indexAmongVisible = visible.indexOf(this.items[index]);
      var step = Math.abs(this.itemOffset) || 0;
      var maxIndex = Math.max(this.totalPages, step ? Math.ceil((this.scrollWidth - this.clientWidth) / step - 0.05) : 0);
      index = this.items.indexOf(visible[Math.min(maxIndex, indexAmongVisible, visible.length - 1)]);
      this._selectedIndex = index;
      this._dispatchEvent('carousel:select', index);
      if (index !== indexBeforeChange || force) {
        var fromSlide = this.items[indexBeforeChange], toSlide = this.items[index];
        this._dispatchEvent('carousel:change', index);
        this._transitionTo(fromSlide, toSlide, { animate: animate });
      }
    };
  });
})();

/* ==========================================================================
   Accueil, bandeau d'avis (snippets/sl-avis-clients.liquid, styles : sl-theme.css, 2.6)
   2 nov. 2026, Claude, demande de Dawei : la rangée défile toute seule, lentement, et la personne
   peut aussi la faire glisser elle-même (doigt, trackpad, souris). Le défilement automatique s'arrête
   au survol (reprise immédiate quand la souris s'en va) et pendant que la personne fait défiler (reprise 3 s après). Il ne tourne que quand le
   bandeau est à l'écran, et jamais si le visiteur a désactivé les animations.
   La liste est écrite deux fois : arrivé à la moitié, on recule d'une moitié, sans que ça paraisse.
   La ligne sous les avis (.sl-avis__progres) suit la position, et on peut cliquer ou glisser dessus.
   ========================================================================== */
(function () {
  var VITESSE = 40; /* pixels par seconde */
  var PAUSE = 3000; /* millisecondes après une action de la personne */
  function preparer(piste) {
    if (piste.dataset.slAvis) return;
    piste.dataset.slAvis = '1';
    var rang = piste.querySelector('.sl-avis__rang');
    if (!rang) return;
    var progres = piste.parentNode.querySelector('.sl-avis__progres');
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pos = piste.scrollLeft, visible = false, survol = false, reprise = 0, dernier = 0, boucle = 0, glisse = null;
    function moitie() { return rang.scrollWidth / 2; }
    function attendre() { reprise = performance.now() + PAUSE; }
    function etendue() { return reduit ? piste.scrollWidth - piste.clientWidth : moitie(); }
    function montrer() {
      if (!progres) return;
      var e = etendue();
      var f = e > 0 ? piste.scrollLeft / e : 0;
      progres.style.setProperty('--scroll-progress', Math.max(0, Math.min(1, f)).toFixed(4));
    }
    function ramener() {
      /* Au-delà de la moitié, on recule d'une moitié : la 2e copie est identique à la 1re. */
      var m = moitie();
      if (reduit) return;
      if (m <= 0) return;
      if (pos < m) return;
      pos -= m;
      piste.scrollLeft = pos;
      if (glisse) glisse.depart -= m;
    }
    function tourner(t) {
      boucle = 0;
      if (!visible) { dernier = 0; return; }
      if (document.hidden) { dernier = 0; return; }
      if (!survol && !glisse && t >= reprise) {
        var dt = dernier ? Math.min(t - dernier, 60) : 0;
        pos += VITESSE * dt / 1000;
        piste.scrollLeft = pos;
        ramener();
      }
      dernier = t;
      boucle = requestAnimationFrame(tourner);
    }
    function lancer() {
      if (reduit) return;
      if (boucle) return;
      dernier = 0;
      boucle = requestAnimationFrame(tourner);
    }
    /* Défilement fait par la personne : on suit sa position et l'automatique attend. */
    piste.addEventListener('scroll', function () {
      if (Math.abs(piste.scrollLeft - pos) > 2) {
        pos = piste.scrollLeft;
        ramener();
        attendre();
      }
      montrer();
    }, { passive: true });
    /* Cliquer ou glisser sur la ligne sous les avis. */
    var barre = progres ? progres.parentNode : null;
    if (barre) {
      var tire = false;
      var aller = function (x) {
        var r = progres.getBoundingClientRect();
        var f = Math.max(0, Math.min(0.999, (x - r.left) / r.width));
        piste.scrollLeft = f * etendue();
        attendre();
      };
      barre.addEventListener('pointerdown', function (e) {
        if (e.target.closest && e.target.closest('.scrollbar__buttons')) return; /* 3 nov. 2026 : un clic sur les flèches ne déplace pas la ligne */
        tire = true;
        if (barre.setPointerCapture) barre.setPointerCapture(e.pointerId);
        aller(e.clientX);
      });
      barre.addEventListener('pointermove', function (e) { if (tire) aller(e.clientX); });
      barre.addEventListener('pointerup', function () { tire = false; });
      barre.addEventListener('pointercancel', function () { tire = false; });
    }
    /* Flèches précédent / suivant (3 nov. 2026, Claude, demande de Dawei) : comme les carrousels de produits,
       une carte à la fois, alignée sur le bord d'une carte. Le défilement automatique attend 3 s ensuite.
       Avant d'arriver au bout d'une copie de la liste, on saute d'une moitié pour que l'animation ne soit pas coupée. */
    if (barre) {
      barre.querySelectorAll('.sl-avis__fleche').forEach(function (fleche) {
        fleche.addEventListener('click', function () {
          var carte = rang.querySelector('.sl-avis__carte');
          if (!carte) return;
          var pas = carte.getBoundingClientRect().width + (parseFloat(getComputedStyle(carte).marginRight) || 0);
          var sens = parseInt(fleche.getAttribute('data-sens'), 10) < 0 ? -1 : 1;
          var i = piste.scrollLeft / pas;
          var k = sens > 0 ? Math.floor(i + 0.05) + 1 : Math.ceil(i - 0.05) - 1; /* numéro de la carte visée */
          var m = moitie(), n = Math.round(m / pas); /* n = nombre de cartes dans une copie */
          if (!reduit && m > 0 && n > 0) {
            if (k > n) { piste.scrollLeft = 0; k = 1; } /* au bout de la 1re copie : on repart du début, même image */
            if (k < 0) { piste.scrollLeft = m; k = n - 1; } /* au début : on passe au début de la 2e copie, même image */
          }
          pos = piste.scrollLeft;
          attendre();
          piste.scrollTo({ left: Math.max(0, k * pas), behavior: reduit ? 'auto' : 'smooth' });
        });
      });
    }
    ['wheel', 'touchstart', 'keydown'].forEach(function (nom) {
      piste.addEventListener(nom, attendre, { passive: true });
    });
    piste.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') survol = true; });
    piste.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      survol = false;
      reprise = 0; /* 2 nov. 2026 (nuit), demande de Dawei : reprise immédiate quand la souris quitte le bandeau, plus de pause de 3 s */
    });
    /* Glisser à la souris sur ordinateur. Au doigt, le défilement du navigateur s'en occupe. */
    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      glisse = { x: e.clientX, depart: piste.scrollLeft };
      piste.classList.add('is-glisse');
    });
    window.addEventListener('pointermove', function (e) {
      if (!glisse) return;
      piste.scrollLeft = glisse.depart - (e.clientX - glisse.x);
    });
    window.addEventListener('pointerup', function () {
      if (!glisse) return;
      glisse = null;
      piste.classList.remove('is-glisse');
      attendre();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        visible = entrees[entrees.length - 1].isIntersecting;
        if (visible) lancer();
      }, { rootMargin: '100px 0px' }).observe(piste);
    } else {
      visible = true;
      lancer();
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && visible) lancer();
    });
  }
  function tout() { document.querySelectorAll('.sl-avis__piste').forEach(preparer); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
})();
